/**
 * resourceBlockers — pure helper for splitting the precheck response's
 * per-resource `blockedBy` / `maintenance` strings into two maps: one that
 * gates submit, one that is display-only.
 *
 * @module resourceBlockers
 */

/**
 * Build the HARD-blocker map (submit gate) and the maintenance INFO map
 * (display-only) from a `check-event-params` response `resources` array.
 *
 * `blockedBy` (pilot/SIC/instructor access restrictions, resource-blocked-by-
 * resource) is the only source that may gate submit. `maintenance` — the
 * resource is on maintenance during the requested window — is display-only:
 * legacy (`Calendar.php:2990-2997`) returns it as informational text on every
 * surface and never treats it as a submit blocker for a reservable
 * aircraft/sim. Keeping it out of `blockedByMap` is what makes that true here.
 *
 * @param {Array<Object>|null|undefined} resources
 * @returns {{ blockedByMap: Object<string, string[]>, maintenanceInfoMap: Object<string, string[]> }}
 */
export function buildResourceBlockerMaps(resources) {
	const blockedByMap = {};
	const maintenanceInfoMap = {};

	(Array.isArray(resources) ? resources : []).forEach(item => {
		const id = item?.resourceID ?? item?.id;
		if (id == null) return;

		const blockers = Array.isArray(item.blockedBy) ? item.blockedBy : [];
		if (blockers.length > 0) {
			blockedByMap[String(id)] = blockers;
		}

		if (item.maintenance) {
			maintenanceInfoMap[String(id)] = [item.maintenance.trim()];
		}
	});

	return { blockedByMap, maintenanceInfoMap };
}
